import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResult } from '../../entities/shared/paginated-result.entity';
import { ProductActionType } from '../../enums/product-actions/product-action-type.enum';
import { AbstractHttpService } from '../../services/abstract-http.service';
import { ProductAction } from './entities/product-action.entity';
import { ProductBase } from './entities/product-base.entity';
import { ProductReference } from './entities/product-reference.entity';
import { Product } from './entities/product.entity';
import { PaginatedProductQuery, ProductQuery } from './queries/product.query';

@Injectable({
  providedIn: 'root',
})
export class ProductsApi extends AbstractHttpService {
  endpoint = 'products';

  create(data: ProductBase): Observable<Product> {
    return this.post<ProductBase, Product>(data);
  }

  findAll(query: PaginatedProductQuery): Observable<PaginatedResult<Product>> {
    return this.get<PaginatedResult<Product>>({ query });
  }

  findAllCompact(query?: ProductQuery): Observable<ProductReference[]> {
    return this.get<ProductReference[]>({ path: 'compact', query });
  }

  findOne(id: number): Observable<Product> {
    return this.get<Product>({ path: id });
  }

  update(id: number, data: ProductBase): Observable<Product> {
    return this.patch<ProductBase, Product>(data, { path: id });
  }

  deleteOne(id: number): Observable<Product> {
    return this.delete<Product>({ path: id });
  }

  executeProductAction(_type: ProductActionType, _action: ProductAction): Observable<Product> {
    throw new Error('Method not implemented.');
  }
}
